import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  fieldErrorCondition(
    fieldName: AbstractControl | null,
    additionalCheck: boolean = false,
    formSubmit: boolean = false
  ): boolean {
    if (additionalCheck) {
      return true;
    }

    if (fieldName) {
      return (
        fieldName.invalid &&
        (fieldName.dirty || fieldName.touched || formSubmit)
      );
    }
    return false;
  }

  /**
   * Build url parameters key and value pairs from array or object
   * @param obj
   */
  urlParam(obj: Record<string, string | number | boolean>): string {
    return Object.keys(obj)
      .map((k) => k + '=' + encodeURIComponent(obj[k]))
      .join('&');
  }

  isEmptyOrNull(object: string | undefined) {
    return object === null || object === undefined || object.trim() === '';
  }

  undefinedOrNull(object: unknown) {
    return object === null || object === undefined;
  }

  getDateString(inDate: { format: (f: string) => string } | null | undefined, dateFirst?: boolean): string | null {
    if (dateFirst) {
      return inDate ? inDate.format('DD-MM-yyyy') : null;
    } else {
      return inDate ? inDate.format('MM-DD-yyyy') : null;
    }
  }

  getMonth(inDate: Date | undefined) {
    return inDate ? inDate.getMonth() + 1 : null;
  }

  getYear(inDate: Date | undefined) {
    return inDate ? inDate.getFullYear() : null;
  }

  // //true = 1 amnd False = 0
  // getBooleanNumber(inVar: boolean | null): number | null {
  //   return inVar === null ? inVar : inVar ? 1 : 0;
  // }

  // getNumberToBoolean(inVar: string | null): boolean | null {
  //   return inVar === null ? inVar : inVar === '1' ? true : false;
  // }

  getDateFormatString(inDate: Date, _inFormat: string = 'dd-MM-yyyy'): string {
    return `${inDate.getFullYear()}-${ (inDate.getMonth()+ 1).toString().padStart(2, '0')}-${inDate.getDate().toString().padStart(2, '0')}`;
  }

  getImageSrcName(imageElement?: string | undefined): string | null {
    let m;
    const rex = /<img[^>]+src="?([^"\s]+)"?[^>]*>/g;

    if(!imageElement){
      return null;
    }

    imageElement = imageElement.replace('"', '"');
    while ((m = rex.exec(imageElement))) {
       return m[1];
    }
    return null;
  }

  getImageAltText(imageElement: string): string | null {
    let m;
    const rex = /alt="([\s\w]*)"+[^>]*/g;

    imageElement = imageElement.replace('"', '"');
    //console.log(str);
    while ((m = rex.exec(imageElement))) {
      // urls.push( m[1] );
      return m[1];
    }
    return null;
  }
}

export const UW_DATE_FORMATS = {
  parse: {
    dateInput: ['DD-MM-YYYY'],
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const UW_DATE_FORMATS_EXEMPTION = {
  parse: {
    dateInput: ['YYYY-MM-DD'],
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


export function removePlaceholders(inString: string | null){
  const placeHolderRegex = /(?:%)(.*)(?=%)/gi;
  const percentRegex = /%/gi;
  return inString ? inString.replace(placeHolderRegex,'').replace(percentRegex,''): inString;
}

export function validateAllFormFields(formGroup: UntypedFormGroup) {
  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);
    if (control instanceof UntypedFormControl) {
      if (control && !control.disabled) {
        control.markAsTouched({ onlySelf: true });
      }      
    } else if (control instanceof UntypedFormGroup) {
      validateAllFormFields(control);
    }
  });
}
